import React from "react";
import { DataBox } from "./DataBox";
import { PageHeader } from "./PageHeader";

export function ManageAssetsList() {
    return (
        <>
            <PageHeader />
            <DataBox />
        </>
    );
}

